const roles = {
  SUPERUSER: {
    name: 'Superuser',
    hidden: true,
    roles: [
      'ADMIN'
    ],
    privileges: [
      'User.Create',
      'User.Read',
      'User.Update',
      'User.Delete',
      'Integration.Create',
      'Integration.Read',
      'Integration.Update',
      'Integration.Delete'
    ]
  },
  ADMIN: {
    name: 'Admin',
    description: 'Full access, including managing members and integrations.',
    roles: [
      'TECHNICAL',
      'CONTENT'
    ],
    privileges: [
      'AccountUser.Create',
      'AccountUser.Read',
      'AccountUser.Update',
      'AccountUser.Delete',
      'Integration.Read'
    ]
  },
  TECHNICAL: {
    name: 'Technical',
    description: 'Ability to make technical data changes.',
    privileges: [
      // Define any privileges the TECHNICAL role has access to
      'Page.Read',
      'Page.Update',
      'Integration.Read',
      'ImageOptimization.Read',
      'ImageOptimization.Update',
      'ImageOptimization.Delete'
    ],
    modules: []
  },
  CONTENT: {
    name: 'Content',
    description: 'Create, edit, and publish page content.',
    privileges: [
      'File.Create',
      'File.Delete',
      'Page.Create',
      'Page.Read',
      'Page.Update',
      'Page.Delete',
      'Page.Publish',
      'PageComment.Create',
      'PageComment.Read',
      'PageComment.Update',
      'PageComment.Delete',
      'PageUser.Create',
      'PageUser.Read',
      'PageUser.Update',
      'PageUser.Delete',
      'Integration.Read'
    ],
    modules: [
      'CONTENT'
    ]
  },
  // Global, user-level grant (lives in User.roles like SUPERUSER — NOT a
  // per-workspace member role, so it is `hidden` from the Members dialog). Set by
  // super admins on Admin > Users. A user can use the AI Generator only where the
  // workspace ALSO has it enabled (Account.modules has AI_GENERATOR, toggled from
  // /admin/accounts). Two-level gate on purpose: the feature is deliberately
  // low-profile for clients. Enforcement: ai_generator routes (server, checks
  // User.roles directly) + PageEditor/EditorContent (client). `superuserOnly`
  // keeps any stale per-workspace copies of this string out of the member chips.
  AI_GENERATOR: {
    name: 'AI Generate Content',
    description: 'Global grant (Admin > Users) to use the AI Generator in workspaces where it is enabled.',
    hidden: true,
    superuserOnly: true,
    privileges: []
  },
  // Standalone feature flag like AI_GENERATOR: members with it (plus SUPERUSERs)
  // can view and write "internal" page comments hidden from other members.
  // Enforcement: page_comment route (server) + CommentsView composer (client).
  INTERNAL: {
    name: 'Internal Comments',
    description: 'View and write internal comments hidden from other members. Requires Content.',
    superuserOnly: true,
    requiresRole: 'CONTENT',
    privileges: []
  }
}

module.exports = roles
